var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoSearchTrend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.88 18.47C20.36 17.7 20.63 16.8 20.57 15.81C20.44 13.66 18.73 11.84 16.6 11.61C13.88 11.31 11.58 13.42 11.58 16.08C11.58 18.57 13.59 20.58 16.07 20.58C16.95 20.58 17.77 20.32 18.46 19.88L20.87 22.29C21.26 22.68 21.9 22.68 22.29 22.29C22.68 21.9 22.68 21.26 22.29 20.87L19.88 18.47ZM16.08 18.58C14.7 18.58 13.58 17.46 13.58 16.08C13.58 14.7 14.7 13.58 16.08 13.58C17.46 13.58 18.58 14.7 18.58 16.08C18.58 17.46 17.46 18.58 16.08 18.58ZM15.72 10.08C14.98 10.1 14.27 10.26 13.62 10.53L13.07 9.69999L9.99 14.71C9.63 15.29 8.82 15.35 8.38 14.84L6.26 12.37L3.2 17.27C2.89 17.76 2.23 17.89 1.76 17.55C1.34 17.24 1.22 16.66 1.5 16.21L5.28 10.16C5.64 9.58999 6.45 9.52999 6.89 10.04L9 12.5L12.18 7.32999C12.56 6.70999 13.46 6.68999 13.86 7.29999L15.72 10.08ZM18.31 10.58C17.67 10.3 16.98 10.13 16.26 10.09L20.8 2.89999C21.11 2.40999 21.77 2.28999 22.23 2.62999C22.66 2.93999 22.77 3.52999 22.49 3.96999L18.31 10.58Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSearchTrend);
export default __webpack_public_path__ + "static/media/ico-search-trend.75fb3f5b1c3f38caf748ddf93bfbcb5a.svg";
export { ForwardRef as ReactComponent };